module.exports = __webpack_public_path__ + "img/file-document.7e0ab033.webp";